import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: {
    unit: 'Review 3',
    id: 'WB4-V2-PV3-P67-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    titleImage: '',
    totalInput: 4,
    exerciseKey: 'img/FriendsPlus/Page67/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page67/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page67/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page67/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/5.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page67/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/7.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page67/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/9.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page67/E1/10.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page67/E1/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page67/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/13.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page67/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/15.jpg', input: 6, },
        { url: 'img/FriendsPlus/Page67/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/17.jpg', input: 7, isCorrect: true, },
        { url: 'img/FriendsPlus/Page67/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/19.jpg', input: 8, isCorrect: true, },
        { url: 'img/FriendsPlus/Page67/E1/20.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page67/E1/21.jpg' },
      ],
    ]
  },
  2: {
    unit: 'Review 3',
    id: 'WB4-V2-PV3-P67-E2',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page67/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page67/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page67/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page67/E2/3.jpg', input: true, answer: "work" },
        { url: 'img/FriendsPlus/Page67/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page67/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page67/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page67/E2/7.jpg', input: true, answer: "Yes" },
        { url: 'img/FriendsPlus/Page67/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page67/E2/9.jpg', input: true, answer: "doesn't" },
        { url: 'img/FriendsPlus/Page67/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page67/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page67/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page67/E2/13.jpg', input: true, answer: "she" },
        { url: 'img/FriendsPlus/Page67/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page67/E2/15.jpg', input: true, answer: "nurse" },
        { url: 'img/FriendsPlus/Page67/E2/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page67/E2/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page67/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page67/E2/19.jpg', input: true, answer: "does" },
        { url: 'img/FriendsPlus/Page67/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page67/E2/21.jpg', input: true, answer: "No" },
        { url: 'img/FriendsPlus/Page67/E2/22.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page67/E2/23.jpg' },
      ],




    ]
  },
}
export default json;